<template>
  <div class="full-height-section container-fluid px-0" :style="{ backgroundColor: '#233d72', color: 'white' }">
    <h1 class="page-title">Seguros Empresarial</h1>

    <div class="row gx-0 mx-0">
      <div
        v-for="(servicio, index) in serviciosLimitados"
        :key="index"
        class="col-md-4 col-sm-6 col-12 px-0"
      >
        <div
          class="service-card"
          :style="{
            backgroundImage: `url('${servicio.imagen}')`,
            animationDelay: (0.2 + index * 0.2) + 's'
          }"
          @click="abrirOverlay(servicio)"
        >
          <div class="overlay"></div>
          <div class="service-content">{{ servicio.titulo }}</div>
        </div>
      </div>
    </div>

    <!-- Overlay -->
    <div v-if="overlayVisible" class="custom-overlay">
      <div class="overlay-card">
        <button class="close-btn" @click="cerrarOverlay">×</button>
        <h2 class="overlay-title">{{ overlayData.titulo }}</h2>
        <p class="overlay-description">{{ overlayData.descripcion }}</p>

        <div class="overlay-image-container">
          <img :src="overlayData.imagen" alt="Imagen del seguro" />
        </div>

        <button class="btn btn-warning" @click="irAFormulario">
          Contactar Seguro
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiciosPersonales",
  data() {
    return {
      overlayVisible: false,
      overlayData: {},
      servicios: [
        {
          titulo: "Seguro Vida Grupo",
          imagen: "image/reunion.jpg",
          descripcion:
            "Protege a tu equipo con un respaldo económico ante situaciones imprevistas. Este seguro colectivo brinda tranquilidad a tus colaboradores y fortalece tu compromiso como empleador. Ideal para empresas que valoran a su gente y buscan generar confianza desde el interior.",
          customClass: "custom-card-size",
        },
        {
          titulo: "Seguro de Transporte",
          imagen: "image/operacion.jpg",
          descripcion:
            "Resguarda tus mercancías en tránsito, ya sea por tierra, aire o mar. Cubre pérdidas, daños o robos durante el trayecto. Ideal para empresas que importan, exportan o distribuyen productos y buscan seguridad total en cada entrega.",
          customClass: "tarjeta-card-size",
        },
        {
          titulo: "Seguro Gastos Médicos Colectivo",
          imagen: "image/cientificos.jpg",
          descripcion:
            "Cuida la salud de tus colaboradores con atención médica privada, hospitalización y tratamientos especializados. Es una de las prestaciones más valoradas y un diferenciador clave para atraer y retener talento. Perfecto para empresas que apuestan por el bienestar integral.",
          customClass: "custom-card-size",
        },
        {
          titulo: "Seguro de Flotillas",
          imagen: "image/concepto.jpg",
          descripcion:
            "Protege todos los vehículos de tu empresa en una sola póliza. Ya sea para reparto, logística o uso ejecutivo, este seguro cubre daños, robos y asistencia vial. Es práctico, eficiente y esencial para operaciones con movilidad constante.",
          customClass: "",
        },
        {
          titulo: "Seguros Empresariales",
          imagen: "image/calculador.avif",
          descripcion:
            "Es el seguro más completo para negocios. Protege tu local, tus equipos, tu inventario y también te respalda si surge un problema con clientes o proveedores. Es una forma inteligente de cuidar lo que tanto esfuerzo te ha costado construir.",
          customClass: "tarjeta-card-size",
        },
      ],
    };
  },
  computed: {
    serviciosLimitados() {
      return this.servicios.slice(0, 5);
    },
  },
  methods: {
    abrirOverlay(servicio) {
      this.overlayData = servicio;
      this.overlayVisible = true;
    },
    cerrarOverlay() {
      this.overlayVisible = false;
    },
    irAFormulario() {
      this.$router.push("/formulario_contacto");
    },
  },
};
</script>

<style scoped>
/* Mantiene lo existente */
.full-height-section {
  min-height: 100vh;
  padding-top: 20px;
}


.page-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.5rem;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
}

.service-card {
  position: relative;
  height: 300px;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;
}
.service-card:hover {
  transform: translateY(-5px) scale(1.03);
}

.service-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  text-align: center;
  z-index: 3;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #233d7265;
}

/* Animación */
@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(30px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* Overlay flotante */
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 15px;
}

.overlay-card {
  background: white;
  color: black;
  padding: 20px;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  position: relative;
  font-family: 'Open Sans', serif;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
}

/* Título más pequeño, en mayúsculas y sin negritas */
.overlay-title {
  margin-bottom: 15px;
  font-weight: normal;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.overlay-description {
  text-align: left;
  margin-bottom: 20px;
}

.overlay-image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.overlay-image-container img {
  max-width: 60%;
  border-radius: 8px;
}

.btn-warning {
  width: 100%;
  max-width: 250px;
}
</style>

